import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import OwnInfoContainer from '../../containers/dashboard/ownInfo.container'
import ReferralCodeContainer from '../../containers/dashboard/referralCode.container'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'
import { scrollToTop } from '../../utils/scrollTo'
import Button from '@material-ui/core/Button'
import store from '../../store'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import FontAwesome from 'react-fontawesome'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
// import CustomProgressBar from './progressBar.component'
import ChartComponent from './barChart.component'

/**
 * The dashboard component to be viewed after user has
 * successfully sign in.
 *
 * @author Pragya Gupta
 */

class Dashboard extends React.Component {
  componentDidMount() {
    this.props.getReferralDiscountByEmail(this.props.selectedUser)
    this.props.getUserLifeTimeInfo()
    this.props.getInvoiceChart()
    this.props.getCustomersChart()
    this.props.getUserTaxInfo()
    this.props.getInvoicesStart()
    this.props.getUserCompanyUpdateInfo()
    this.props.loadProfileStart()
    this.props.resetYear()
    this.props.getInvoiceAndSalaryDetailMonthly(this.props.selectedUser)

    const { userType, getAdminUsersList } = this.props
    if (userType == 2) {
      getAdminUsersList()
    }

    scrollToTop()
  }

  render() {
    return <DashboardComponent {...this.props} />
  }
}
const styles = (theme) => ({
  button: {
    margin: theme.spacing(1)
  },
  dialogButton: {
    margin: theme.spacing(1)
  }
})

const DashboardComponent = ({
  invoiceAmountByMonthlyChartData,
  invoiceChartData,
  topCustomers,
  userType,
  selectedUser,
  classes,
  year,
  resetYear,
  decrementYear,
  incrementYear,
  noCampaign,
  showPopup,
  closeDialogDashboard,
  // total_invoiced_amount,
  reachAnAward,
  service_percentage,
  updateCelebrationStatus,
  getInvoiceAndSalaryDetailMonthly
}) => {
  const history = useHistory()

  const translatedChartData = (chartData, t) => {
    return chartData.labels?.length
      ? {
          ...chartData,
          labels: chartData.labels.map((label) => t(label))
        }
      : { datasets: [], labels: [] }
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            {/* KAS-336 Show campaign title */}
            {noCampaign === true ? null : (
              <div>
                <div
                  style={{
                    backgroundColor: '#F67131',
                    textAlign: 'center',
                    color: '#FFFFFF',
                    fontSize: '13px'
                  }}
                >
                  <p style={{ marginBottom: '0px', fontSize: '15px' }}>
                    {/*PI-312 Referral text changes*/}
                    {t('referral.p1')} {/* {t('referral.p1a')}<br/> */}
                    {/* {t('referral.p1b')}<br/> */}
                    <b
                      onClick={() => {
                        // PI-312 Jump to information section
                        const anchor = document.querySelector('#referral-box')
                        // const anchor = document.querySelector('#tiedo-box')
                        anchor.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center'
                        })
                      }}
                      style={{
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      {t('referral.click')}
                    </b>
                  </p>
                </div>
              </div>
            )}
            <p
              style={{
                marginTop: '10px',
                fontSize: '18px',
                backgroundColor: '#007B8F',
                textAlign: 'center',
                color: '#FFFFFF',
                fontSize: '18px'
              }}
            >
              {t('dashboarInfo.bannerText')}
            </p>
            <div className="container horizontal-view">
              <div className="row">
                {userType === 2 && (
                  <UserSelectorContainer></UserSelectorContainer>
                )}
              </div>
              <div className="row">
                <div className="dashboard-content-header">
                  <h1>{t('dashboarComp.tapah')}</h1>
                </div>
              </div>
              {store.getState().profile.userData.account_number === null ? (
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div
                      className="panel panel-default"
                      style={{ padding: '25px' }}
                    >
                      <p style={{ fontSize: '3vh' }}>
                        {t('warnboard.line1')}{' '}
                        {store.getState().profile.userData.firstname}{' '}
                        {store.getState().profile.userData.lastname}
                      </p>
                      <p style={{ fontSize: '1,5vh' }}>
                        {' '}
                        {t('warnboard.line2')}
                      </p>
                      <p style={{ fontSize: '1,5vh' }}>
                        {' '}
                        {t('warnboard.line3')}
                      </p>
                      <Button
                        style={{
                          marginLeft: '45%',
                          marginRight: '40%',
                          fontSize: '2vh',
                          padding: '10px'
                        }}
                        variant="contained"
                        className={classes.button}
                        onClick={() => history.push('/dashboard/profile')}
                      >
                        {t('warnboard.line4')}
                      </Button>
                    </div>
                  </div>
                </div>
              ) : null}
              {/* <div className="row">
                <div className="dashboard-content-header">
                  <div className="col-xs-12 col-sm-12 col-lg-12">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h3 className="panel-title">
                          {t('dashboarComp.lifetime')}
                        </h3>
                      </div>
                      <div className="panel-body">
                        <CustomProgressBar money={total_invoiced_amount} />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="row">
                {!mobileView && (
                  <div className="dashboard-content-header">
                    <div className="col-xs-12 col-sm-12 col-lg-12">
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <h3
                            className="panel-title"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            <span style={{ margin: '0 10px' }}>
                              <IconButton
                                aria-label="arrow_left"
                                onClick={() => {
                                  decrementYear()
                                  getInvoiceAndSalaryDetailMonthly(selectedUser)
                                }}
                              >
                                <FontAwesome
                                  name="caret-left"
                                  style={{ width: '100%', color: '#ffff' }}
                                />
                              </IconButton>
                            </span>
                            <span> {year}</span>
                            <span style={{ margin: '0 10px' }}>
                              <IconButton
                                aria-label="arrow_right"
                                onClick={() => {
                                  incrementYear()
                                  getInvoiceAndSalaryDetailMonthly(selectedUser)
                                }}
                              >
                                <FontAwesome
                                  name="caret-right"
                                  style={{ width: '100%', color: '#ffff' }}
                                />
                              </IconButton>
                            </span>
                            <IconButton
                              aria-label="arrow_right"
                              onClick={() => {
                                resetYear()
                                getInvoiceAndSalaryDetailMonthly(selectedUser)
                              }}
                            >
                              <FontAwesome
                                name="undo"
                                style={{ width: '100%', color: 'white' }}
                              />
                            </IconButton>
                          </h3>
                        </div>
                        <ChartComponent
                          t={t}
                          data={invoiceAmountByMonthlyChartData}
                          userType={userType}
                          selectedUser={selectedUser}
                        />
                        <div className="panel-footer" />
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="dashboard-content-doughnut">
                    <div className="col-xs-12 col-sm-4 col-lg-4">
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <h3 className="panel-title">
                            {t('dashboarComp.lasku2')}
                          </h3>
                        </div>
                        <div className="panel-body" style={{ height: '43vh' }}>
                          <Doughnut
                            data={
                              userType == 2 && selectedUser.email == undefined
                                ? []
                                : translatedChartData(invoiceChartData, t)
                            }
                            width={100}
                            height={50}
                            options={{
                              legend: {
                                display: false,
                                position: 'right'
                              },
                              maintainAspectRatio: false
                            }}
                          />
                        </div>
                        <div className="panel-footer" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-lg-4">
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <h3 className="panel-title">
                            {t('dashboarComp.top')}
                          </h3>
                        </div>
                        <div className="panel-body" style={{ height: '43vh' }}>
                          <Doughnut
                            data={
                              userType == 2 && selectedUser.email == undefined
                                ? []
                                : topCustomers
                            }
                            width={100}
                            height={50}
                            options={{
                              legend: {
                                display: false,
                                position: 'bottom'
                              },
                              maintainAspectRatio: false
                            }}
                          />
                        </div>
                        <div className="panel-footer" />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-lg-4">
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <h3 className="panel-title">
                            {t('dashboarComp.omat')}
                          </h3>
                        </div>
                        <div
                          style={!mobileView ? { height: '43vh' } : null}
                          className="row"
                        >
                          <OwnInfoContainer />
                        </div>
                        <div
                          className="panel-footer"
                          style={mobileView ? { marginTop: 20 } : null}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* KAS-336 Show campaign form to send email */}
              {noCampaign === true ? null : (
                <div id="referral-box" className="row">
                  <div className="dashboard-content-header">
                    <div className="col-xs-12 col-sm-12 col-lg-12">
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          <h3 className="panel-title">{t('referral.title')}</h3>
                        </div>
                        <div className="panel panel-default">
                          <ReferralCodeContainer />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/*KAS-470 Company notifications is moved to dialog when clicking the bell icon*/}
            </div>
            {/* Kas-336 show dialog welcome new person that is recommended to service */}
            <Dialog
              open={showPopup}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{
                classes: {
                  root: classes.dialog
                }
              }}
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>{t('referral.title1')}</span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('referral.subtitle1')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.dialogButton}
                    onClick={closeDialogDashboard}
                  >
                    {t('referral.btn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog open={reachAnAward}>
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div style={{ margin: 'auto' }}>
                    <span
                      style={{
                        fontSize: '16px',
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '5px'
                      }}
                    >
                      {t('dashboarComp.awardText1')}
                    </span>
                  </div>
                  <div>
                    <FontAwesome
                      name="window-close"
                      style={{
                        color: '#F67131'
                      }}
                      size="lg"
                      onClick={updateCelebrationStatus}
                    />
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    textAlign: 'center'
                  }}
                >
                  <span className={classes.subTitle}>
                    {t('dashboarComp.awardText2') +
                      service_percentage +
                      ' ' +
                      t('dashboarComp.percent')}
                  </span>{' '}
                  <br />
                  <span className={classes.subTitle}>
                    {t('dashboarComp.awardText3')}
                  </span>
                  <br />
                  <img
                    style={{
                      maxHeight: '20em',
                      maxWidth: '20em',
                      objectFit: 'cover',
                      padding: '20px 10px 10px 10px'
                    }}
                    src="../../images/fireworks.png"
                  ></img>
                </DialogContentText>
              </DialogContent>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Dashboard)
